import Vue from "vue";
import Cleave from "vue-cleave-component";

Vue.use(Cleave);
